//const API_BASE_URL = "http://localhost/guidetocomputer/gcweb/admin/api";
const API_BASE_URL = "https://guidetocomputers.org/admin/api";
export default API_BASE_URL;